import { dropBoolean, dropModulo } from 'utils/drops';

const getFormaDePagamentoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'modulo',
    label: 'Módulo',
    type: 'select',
    options: dropModulo,
    multiple: true,
  },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getFormaDePagamentoFilterFields;
